import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { CandidacyPlacement, PlacementQueryParams } from "@/types";

export const useSetPlacement = () => {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return ({
    updatedPlacement,
    placementQueryParams,
  }: {
    updatedPlacement: CandidacyPlacement;
    placementQueryParams: PlacementQueryParams;
  }) => {
    queryClient.setQueryData(
      ["placements", currentCompanyId, currentJobId, placementQueryParams],
      (cachedPlacements: CandidacyPlacement[]) => {
        return cachedPlacements.map((placement) => {
          if (placement.id === updatedPlacement.id) {
            return updatedPlacement;
          }
          return placement;
        });
      },
    );
  };
};
